import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBaseButton, LazyBaseDialog, LazyBaseErrorNotification, LazyBaseInput, LazyCNuxtImg, LazyMainHeader, LazyPageTemplate, LazySourceLabel, LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["BaseButton", LazyBaseButton],
["BaseDialog", LazyBaseDialog],
["BaseErrorNotification", LazyBaseErrorNotification],
["BaseInput", LazyBaseInput],
["CNuxtImg", LazyCNuxtImg],
["MainHeader", LazyMainHeader],
["PageTemplate", LazyPageTemplate],
["SourceLabel", LazySourceLabel],
["NuxtIcon", LazyNuxtIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
